import { d as r } from "../internals/descriptors.js";
import { g as t } from "../internals/global.js";
import { f as s } from "../internals/function-uncurry-this.js";
import { i as e } from "../internals/is-forced.js";
import { i as o } from "../internals/inherit-if-required.js";
import { c as n } from "../internals/create-non-enumerable-property.js";
import "../internals/object-get-own-property-names.js";
import { o as i } from "../internals/object-is-prototype-of.js";
import { i as a } from "../internals/is-regexp.js";
import { t as p } from "../internals/to-string.js";
import { r as l } from "../internals/regexp-get-flags.js";
import { r as m } from "../internals/regexp-sticky-helpers.js";
import { p as f } from "../internals/proxy-accessor.js";
import { d as c } from "../internals/define-built-in.js";
import { f as u } from "../internals/fails.js";
import { h as g } from "../internals/has-own-property.js";
import { i as j } from "../internals/internal-state.js";
import { s as h } from "../internals/set-species.js";
import { w as d } from "../internals/well-known-symbol.js";
import { r as y } from "../internals/regexp-unsupported-dot-all.js";
import { r as x } from "../internals/regexp-unsupported-ncg.js";
import { __exports as w } from "../../../_virtual/object-get-own-property-names.js";
var v = w.f,
  b = j.enforce,
  E = d("match"),
  S = t.RegExp,
  k = S.prototype,
  R = t.SyntaxError,
  _ = s(k.exec),
  A = s("".charAt),
  I = s("".replace),
  D = s("".indexOf),
  O = s("".slice),
  P = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,
  T = /a/g,
  U = /a/g,
  Y = new S(T) !== T,
  q = m.MISSED_STICKY,
  C = m.UNSUPPORTED_Y,
  K = r && (!Y || q || y || x || u(function () {
    return U[E] = !1, S(T) != T || S(U) == U || "/a/i" != S(T, "i");
  })),
  M = function M(r) {
    for (var t, s = r.length, e = 0, o = "", n = !1; e <= s; e++) {
      if ("\\" === (t = A(r, e))) {
        o += t + A(r, ++e);
        continue;
      }
      n || "." !== t ? ("[" === t ? n = !0 : "]" === t && (n = !1), o += t) : o += "[\\s\\S]";
    }
    return o;
  },
  N = function N(r) {
    for (var t, s = r.length, e = 0, o = "", n = [], i = {}, a = !1, p = !1, l = 0, m = ""; e <= s; e++) {
      if ("\\" === (t = A(r, e))) t += A(r, ++e);else if ("]" === t) a = !1;else if (!a) switch (!0) {
        case "[" === t:
          a = !0;
          break;
        case "(" === t:
          _(P, O(r, e + 1)) && (e += 2, p = !0), o += t, l++;
          continue;
        case ">" === t && p:
          if ("" === m || g(i, m)) throw new R("Invalid capture group name");
          i[m] = !0, n[n.length] = [m, l], p = !1, m = "";
          continue;
      }
      p ? m += t : o += t;
    }
    return [o, n];
  };
if (e("RegExp", K)) {
  for (var z = function z(r, t) {
      var s,
        e,
        m,
        f,
        c,
        u,
        g = i(k, this),
        j = a(r),
        h = void 0 === t,
        d = [],
        w = r;
      if (!g && j && h && r.constructor === z) return r;
      if ((j || i(k, r)) && (r = r.source, h && (t = l(w))), r = void 0 === r ? "" : p(r), t = void 0 === t ? "" : p(t), w = r, y && ("dotAll" in T) && (e = !!t && D(t, "s") > -1) && (t = I(t, /s/g, "")), s = t, q && ("sticky" in T) && (m = !!t && D(t, "y") > -1) && C && (t = I(t, /y/g, "")), x && (r = (f = N(r))[0], d = f[1]), c = o(S(r, t), g ? this : k, z), (e || m || d.length) && (u = b(c), e && (u.dotAll = !0, u.raw = z(M(r), s)), m && (u.sticky = !0), d.length && (u.groups = d)), r !== w) try {
        n(c, "source", "" === w ? "(?:)" : w);
      } catch (r) {}
      return c;
    }, B = v(S), F = 0; B.length > F;) f(z, S, B[F++]);
  k.constructor = z, z.prototype = k, c(t, "RegExp", z, {
    constructor: !0
  });
}
h("RegExp");